<div class="dialog">
  <div class="dialog__header">
    <div class="dialog__header-title">
      <h4>{{data.title}}</h4>
      @if(data.subTitle){
          <p>{{data.subTitle}}</p>
      }
    </div>
    <button type="button" class="icon-btn" (click)="close()" aria-label="Close">✕</button>
  </div>
  <div class="dialog__buttons">
    <dsy-button variant="secondary" (click)="data.onCancel()"> {{cancelText}} </dsy-button>
    <dsy-button (click)="data.onConfirm()">{{confirmText}}</dsy-button>
  </div>
</div>
